import React from "react";

export const ManageFidelityContext = React.createContext({
    doEdit: null,
    parentState: null,
});